var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-width-container",style:(("background-image: url(" + (_vm.moduleData.src || '') + ")"))})}
var staticRenderFns = []

export { render, staticRenderFns }